import { render, staticRenderFns } from "./CommonFieldLink.vue?vue&type=template&id=1dededbc&scoped=true"
import script from "./CommonFieldLink.vue?vue&type=script&lang=js"
export * from "./CommonFieldLink.vue?vue&type=script&lang=js"
import style0 from "./CommonFieldLink.vue?vue&type=style&index=0&id=1dededbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dededbc",
  null
  
)

export default component.exports